<template>
  <div
    class="fm-form-input w-full dark:bg-slate-700"
    :class="[label ? 'mt-2' : '']"
  >
    <label v-if="label">
      {{ label }}
    </label>
    <div
      class="flex w-full flex-row justify-end rounded-md bg-white px-3 py-2 sm:text-sm dark:bg-slate-800"
    >
      {{ displayedValue }}
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BaseShowPriceLabel',
  props: {
    label: {
      type: String,
      required: false,
      default: ''
    },
    value: {
      type: [String, Number, Boolean],
      required: false,
      default: null
    },
    currency: {
      type: String,
      required: false,
      default: null
    },
    priceType: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      currencySettings: 'metadata/getDefaultCurrencyMetadata'
    }),
    defaultCurrency() {
      return this.currency ?? this.currencySettings
    },
    intlLocale() {
      return this.$i18n.locale && this.$i18n.locale !== 'default'
        ? this.$i18n.locale.replace('_', '-')
        : 'fr-BE'
    },
    normalizedValue() {
      if (
        this.value === null ||
        this.value === undefined ||
        this.value === ''
      ) {
        return null
      }
      const numericValue =
        typeof this.value === 'string'
          ? Number(this.value.replace(',', '.').trim())
          : Number(this.value)
      return isNaN(numericValue) ? null : numericValue
    },
    displayedValue() {
      return this.normalizedValue === null
        ? '-'
        : this.normalizedValue.toLocaleString(this.intlLocale, {
            style: 'currency',
            currency: this.defaultCurrency
          })
    }
  }
}
</script>
